import _clonedeep from 'lodash.clonedeep';
import React from 'react';
import { Accordion, Container } from 'react-bootstrap';
import {
  FULL_SIZE,
  HALF_SIZE,
  MODIFIER_LOCATION,
  REACT_APP_CLOUD_FRONT,
} from '../../../constants';
import { verifyStatus } from '../../../helpers/customizedItem/customizedItem.helper';
import {
  isSandwichTrayItem,
  resolveSandwichTrayChipsMax,
} from '../../../helpers/sandwichTrayChips.helper';
import { mapSizesKey } from '../../../models/item.model';
import {
  addAdditionalPrice,
  calculateAndUpdateTotalAdditionalPrice,
} from '../../../priceCalculation/itemsAsModifierPrice';
import { useAppDispatch, useAppSelector } from '../../../redux/store/store';
import { useLocation } from 'react-router-dom';
import styleClasses from '../../../components/Molecules/Card/CounterCard/counterCard.module.scss';
import { give_me_my_classes } from '../../../helpers/helperMethods';

type ItemAsModifierState = {
  itemsAsModifier: any[];
  setItemsAsModifier: React.Dispatch<React.SetStateAction<any[]>>;
};

const ItemsAsModifiers: React.FC<{
  itemAsModifiers: any[];
  cardColSize?: string;
  isPackege?: boolean;
  itemAsModifierState: ItemAsModifierState;
  itemsAsModifiersToHandleScroll?: {
    refToScrollToMissingRequiredItemAsModifiers: Record<number, React.RefObject<HTMLSpanElement>>;
    isItemAsModifierSelected: { status: boolean; highLightArea: number };
  };
  openItemInfoModal?: (item: any) => void;
  parentTrayItem?: any;
  subItemBucketSlot?: number;
}> = (props) => {
  const {
    itemAsModifiers,
    cardColSize,
    itemAsModifierState,
    itemsAsModifiersToHandleScroll,
    openItemInfoModal,
    parentTrayItem,
    subItemBucketSlot = 1,
  } = props;
  const order = useAppSelector((state: any) => state.itemCustomization);

  const query = new URLSearchParams(useLocation().search);
  const isPackage = Boolean(query.get('is_package'));

  const {
    onAddModifier,
    onRemoveModifier,
    selectedItemAsAnModifier,
    lengthOfSelectedItems,
  } = useItemAsModifiers(
    _clonedeep(itemAsModifiers),
    order,
    itemAsModifierState
  );

  const isLimitCompleted = (currentItemGroup: any) => {
    const currentItemGroupId = currentItemGroup.id;
    const { itemsAsModifier } = itemAsModifierState;
    const selectedItems = itemsAsModifier?.find(
      (row) => row.id === currentItemGroupId
    )?.selectedItems;
    if (!selectedItems || selectedItems?.length <= 0) return false;
    const chipsMax =
      parentTrayItem && isSandwichTrayItem(parentTrayItem)
        ? resolveSandwichTrayChipsMax(
            parentTrayItem,
            subItemBucketSlot,
            currentItemGroupId
          )
        : null;

    if (chipsMax != null) {
      return chipsMax <= lengthOfSelectedItems(currentItemGroupId);
    }

    if (order.size === HALF_SIZE.id) {
      return (
        currentItemGroup.half_item_count <=
        lengthOfSelectedItems(currentItemGroupId)
      );
    }
    if (order.size === FULL_SIZE.id) {
      return (
        currentItemGroup.full_item_count <=
        lengthOfSelectedItems(currentItemGroupId)
      );
    }
    return false;
  };

  const showRedBorderAnimation = (id: number) => {
    return itemsAsModifiersToHandleScroll
      ? itemsAsModifiersToHandleScroll.isItemAsModifierSelected.status &&
          itemsAsModifiersToHandleScroll.isItemAsModifierSelected
            .highLightArea === id
      : false;
  };

  const itemAsModifierGroupLabel = (items: any) => {
    return (
      <span
        ref={
          itemsAsModifiersToHandleScroll?.refToScrollToMissingRequiredItemAsModifiers?.[
            items.id
          ] as unknown as React.RefObject<HTMLSpanElement>
        }
        className={`d-block text-capitalize ${
          isPackage ? 'clr-dark-gray f-s23 f-sm-s18 text-capitalize' : ''
        }`}
      >
        {items?.label}
        {!isLimitCompleted(items) ? (
          <span className="f-s13 f-w6 font-rale clr-dark-green d-block lh-normal">
            <span className="caption fs-14">
              You are missing items in this category
            </span>
          </span>
        ) : null}
      </span>
    );
  };

  const handleInfoOutline = (e: React.MouseEvent, row: any) => {
    e.stopPropagation();
    openItemInfoModal?.(row);
  };

  const itemAsModifierGroupModifiers = (items: any) => {
    return (
      <div className="single-item-modifiers row">
        {(items.items_as_modifier ?? []).map((row: any) => {
          const selectedItem = selectedItemAsAnModifier(items.id, row);
          const active = verifyStatus(row, MODIFIER_LOCATION);
          const limitDone = isLimitCompleted(items);
          const isDisabled = !active || (limitDone && !selectedItem?.isSelected);
          return (
            <div
              key={row?.id}
              className={`item__modifier_item mb-3 ${cardColSize ?? ''} col-4 col-md-3 col-lg-2 px-2`}
            >
              <div
                className={`${
                  selectedItem?.isSelected
                    ? give_me_my_classes(['add_on_item_wrap', 'selected'], styleClasses)
                    : ''
                } ${styleClasses.item_wrap} add_on_item_wrap shadow-box d-flex flex-column h-100 ${
                  showRedBorderAnimation(items.id) && !selectedItem?.quantity
                    ? 'border-size-select'
                    : ''
                } ${isDisabled ? 'opacity-50' : ''}`}
                role="presentation"
                onClick={() => {
                  if (active && !limitDone && !selectedItem?.quantity) {
                    onAddModifier(items, row);
                  }
                }}
              >
                {openItemInfoModal ? (
                  <button
                    type="button"
                    className="btn btn-link p-0 float-end d-none d-md-block position-absolute top-0 end-0 mt-2 me-2"
                    onClick={(e) => handleInfoOutline(e, row)}
                  >
                    i
                  </button>
                ) : null}
                <div
                  className={`${styleClasses.items_image} mb-0 d-flex align-items-center justify-content-center items__image_wrap`}
                >
                  <img
                    src={`${REACT_APP_CLOUD_FRONT}${row?.image}`}
                    alt={row?.name ?? ''}
                    className={`img-fluid ${isDisabled && !selectedItem?.isSelected ? 'opacity-50' : ''}`}
                  />
                </div>
                <div className={`${styleClasses.items_inn_content} items__inn_content`}>
                  <h3 className={`${styleClasses.item_title} font-rale mb-2`}>
                    {row?.name}
                    <span className={`${styleClasses.tooltiptext} d-none d-md-block`}>
                      {row?.name}
                    </span>
                  </h3>
                </div>
                <div
                  className={`${styleClasses.item_increments} mb-2 d-flex justify-content-between align-items-center px-2`}
             
                >
                  <button
                    type="button"
                    className={`${styleClasses.decrease_btns} btn btn_custom`}
                    disabled={!active || !selectedItem?.quantity}
                    onClick={(e) => {
                      e.stopPropagation();
                      onRemoveModifier(items, row);
                    }}
                  >
                    Decrease
                  </button>
                  <span className={styleClasses.counts}>{selectedItem?.quantity ?? 0}</span>
                  <button
                    type="button"
                    className={`${styleClasses.increase_btns} btn btn_custom`}
                    disabled={!active || limitDone}
                    onClick={(e) => {
                      e.stopPropagation();
                      onAddModifier(items, row);
                    }}
                  >
                    Increase
                  </button>
                </div>
                {selectedItem?.additionalPrice ? (
                  <h6 className="order_item_detals__NZQqW f-s10 font-rale d-flex justify-content-between mb-0 lh-normal text-nowrap px-2">
                    <span className="text-danger font-Visby-cf f-w5 w-100 text-end">
                      +${selectedItem.additionalPrice.toFixed(2)}
                    </span>
                  </h6>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      {itemAsModifiers?.length > 0 &&
        itemAsModifiers?.map((items, index) => (
          <Container fluid className="modifiersContainer" key={`${items.id}-${index}`}>
            <Accordion
              defaultActiveKey={['1']}
              alwaysOpen
              className="theme-custom-accordions item-customization-acc"
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>{itemAsModifierGroupLabel(items)}</Accordion.Header>
                <Accordion.Body>{itemAsModifierGroupModifiers(items)}</Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Container>
        ))}
    </>
  );
};

function useItemAsModifiers(
  items: any,
  order: any,
  itemAsModifierState: ItemAsModifierState
) {
  const { itemsAsModifier, setItemsAsModifier } = itemAsModifierState;
  const dispatch = useAppDispatch();

  function onAddModifier(currentItemsGroup: any, newItem: any) {
    calculateAndUpdateTotalAdditionalPrice(itemsAsModifier, '-', dispatch);
    const groupId: number = currentItemsGroup.id;
    const nextItem = {
      ...newItem,
      quantity: currentItemsGroup.item_counter_increment,
      additionalPrice: newItem?.additionalPrice ?? 0,
      isSelected: true,
    };
    if (newItem[mapSizesKey[order.size]] && !newItem.isByDefault) {
      nextItem.isByDefault = true;
      nextItem.actualQuantity =
        currentItemsGroup.item_counter_increment *
        newItem[mapSizesKey[order.size]];
    }
    const newItemsAsModifiers = [...itemsAsModifier];
    const groupRow = newItemsAsModifiers.find((r) => r.id === groupId);
    if (!groupRow) return;
    groupRow.selectedItems.push(nextItem);
    const itemsWithAdditionalPrice = addAdditionalPrice({
      items: groupRow.selectedItems,
      currentItemsGroup,
      order,
    });
    groupRow.selectedItems = itemsWithAdditionalPrice;
    calculateAndUpdateTotalAdditionalPrice(newItemsAsModifiers, '+', dispatch);
    setItemsAsModifier(newItemsAsModifiers);
  }

  function lastIndexOfItemAsModifiers(array: any[], key: any): number {
    for (let i = array.length - 1; i >= 0; i--) {
      if (array[i].id === key.id) return i;
    }
    return -1;
  }

  function onRemoveModifier(currentItemsGroup: any, newItem: any): void {
    calculateAndUpdateTotalAdditionalPrice(itemsAsModifier, '-', dispatch);
    const groupId = currentItemsGroup.id;
    const activeItems = currentActiveItems(groupId);
    const activeItemIndex = lastIndexOfItemAsModifiers(activeItems, newItem);
    if (activeItemIndex < 0) return;
    if (
      activeItems[activeItemIndex].quantity ===
      currentItemsGroup.item_counter_increment
    ) {
      activeItems.splice(activeItemIndex, 1);
    } else if (
      activeItems[activeItemIndex].quantity >
      currentItemsGroup.item_counter_increment
    ) {
      activeItems[activeItemIndex].quantity -=
        currentItemsGroup.item_counter_increment;
    }

    const newItemsAsModifiers = [...itemsAsModifier];
    const groupRow = newItemsAsModifiers.find((r) => r.id === groupId);
    if (!groupRow) return;
    groupRow.selectedItems = addAdditionalPrice({
      items: activeItems,
      currentItemsGroup,
      order,
    });
    calculateAndUpdateTotalAdditionalPrice(newItemsAsModifiers, '+', dispatch);

    setItemsAsModifier(newItemsAsModifiers);
  }

  function selectedItemAsAnModifier(groupId: number, item: any) {
    const currentItemGroup = _clonedeep(itemsAsModifier)?.find(
      (itemGroup: { id: number }) => itemGroup.id === groupId
    )?.selectedItems;
    const currentItem = currentItemGroup?.find(
      (selected: any) => selected.id === item.id
    );
    if (currentItem) {
      currentItem.quantity = currentItemGroup
        .filter((selected: any) => selected.id === item.id)
        ?.reduce((acc: number, sub: any) => acc + sub.quantity, 0);
      currentItem.additionalPrice = currentItemGroup
        .filter((selected: any) => selected.id === item.id)
        ?.reduce((acc: number, sub: any) => acc + (sub.additionalPrice ?? 0), 0);
    }
    return currentItem;
  }

  function lengthOfSelectedItems(currentItemGroupId: number): number {
    const currentItems = itemsAsModifier.find(
      (itemGroup: { id: number }) => itemGroup.id === currentItemGroupId
    )?.selectedItems;
    if (!currentItems) return 0;
    return currentItems.reduce((acc: number, sub: any) => acc + sub.quantity, 0);
  }

  function currentActiveItems(itemGroupId: number): any[] {
    const row = itemsAsModifier?.find(
      (currentItemsGroup) => currentItemsGroup.id === itemGroupId
    );
    return [...(row?.selectedItems ?? [])];
  }

  return {
    onAddModifier,
    onRemoveModifier,
    selectedItemAsAnModifier,
    lengthOfSelectedItems,
  };
}

export default ItemsAsModifiers;
